import { shallowEqual, useSelector } from 'react-redux'

import CampaignShareModal from '@components/Campaign/Share/Modal'
import { ActionIconWrapper } from '@components/Inbox/TitleBar/TitleBar.styled'
import ActionIcon from '@components/UI/ActionIcon'
import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { EventTrackingNames } from '@enums'
import { useModal } from '@hooks/useModal'
import { selectShareUrl } from '@store/campaigns'
import { IApplicationState } from '@store/index'
import Theme from '@theme'

interface IProps {
  campaignId: number
}

const CampaignShareTrigger: React.FC<IProps> = ({ campaignId }) => {
  const { showModal } = useModal()

  const onOpenModal = () => showModal(CampaignShareModal, { campaignId })

  const { hasShareUrl } = useSelector((state: IApplicationState) => ({
    hasShareUrl: Boolean(selectShareUrl(state, campaignId)),
  }), shallowEqual)

  if (!hasShareUrl) {
    return null
  }

  return (
    <ActionIconWrapper>
      <ConnectedTrackedRoute
        eventName={EventTrackingNames.ToolbarShareCampaignDeeplink}
        campaignId={campaignId}
      >
        <ActionIcon
          disabled={false}
          data-testid="campaign-share-trigger"
          glyph="share-universal"
          color={Theme.grey900Color}
          size={1.5}
          onClick={onOpenModal}
        />
      </ConnectedTrackedRoute>
    </ActionIconWrapper>
  )
}

export default CampaignShareTrigger
